<template>
  <div>
    <c-box
      :title="'Источники трафика за ' + date.format('MMM')"
      :loading="loading"
      shadow
    >
      <div class="row">
        <template v-if="!loading && data.length">
          <div class="col-md-7">
            <metrics-table :data="data.map(i => ({name: i.ИсточникТрафика, visits: i.Визиты}))" />
          </div>
          <div class="col-md-5">
            <c-doughnut-chart
              class="doughnut-chart"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </template>
        <no-data v-if="!loading && !data.length" />
      </div>
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import moment from 'moment'
import CDoughnutChart from '../../../../../../../resources/js/components/ui/CDoughnutChart.vue'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import MetricsTable from '../../../../../../../resources/js/components/MetricsTable.vue'

export default {
  name: 'TrafficSources',
  components: { MetricsTable, CDoughnutChart, NoData, CBox },
  mixins: [diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    },
    month: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          callbacks: {
            label (tooltipItem, data) {
              return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    date () {
      return moment().month(this.month)
    },
    chartData () {
      return {
        labels: this.data.map(i => i.ИсточникТрафика),
        datasets: [
          {
            data: this.data.map(i => i.ДоляВОбщемЧислеВизитов),
            backgroundColor: this.data.map((item, index) => this.getNextDiagramColor(index))
          }
        ]
      }
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.doughnut-chart {
  @media (max-width: $smBreakpoint) {
    width: 50%;
    margin: 0 auto 20px auto;
  }

  @media (max-width: $xsBreakpoint) {
    width: 100%;
  }
}
</style>
